import {Component, Injector, OnInit} from '@angular/core';
import {VideoCategoryDto, VideoDto, VideoServiceProxy} from '../../../shared/service-proxies/service-proxies';
import {DomSanitizer} from '@angular/platform-browser';
import {AppConsts} from '../../../assets/AppConsts';

@Component({
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.less']
})
export class CategoryComponent implements OnInit {
  categorys: VideoCategoryDto[] = [];
  isActive: boolean;
  videos: VideoDto[];
  pageNo: number;
  pageSize: number;
  imageBaseUrl: string;
  constructor(injector: Injector, private _videoService: VideoServiceProxy, private sanitizer: DomSanitizer) {
    this.imageBaseUrl =  AppConsts.imageBaseUrl;
    this.pageSize = 50;
    this.pageNo = 1;
  }
  ngOnInit(): void {
    this._videoService.categorys(0).subscribe((result) => {
      this.categorys = result;
      this.isActive = false;
      $('#category').addClass('focus');
    });
  }

  showDetails(id: number): void {
    window.location.href = '/app/list?catId=' + id;
  }
  showVideo(id: number): void {
    window.location.href = '/app/show?id=' + id;
  }

  changeTab(isActive: boolean): void {
    this.isActive = isActive;
    if (isActive === true) {
      $('#all').addClass('focus');
      $('#category').removeClass('focus');
      this._videoService.videos(this.pageNo, this.pageSize, null).subscribe((result) => {
        this.videos = result.data;
        for (let i = 0; i < this.videos.length; i++ ) {
          this.videos[i].cover_org = this.imageBaseUrl + this.videos[i].cover_org;
        }
      });
    } else {
      $('#all').removeClass('focus');
      $('#category').addClass('focus');
    }
  }
  getSalfUrl(url: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
  loadmore(): void {
    this.pageNo += 1;
    this._videoService.videos(this.pageNo, this.pageSize, null).subscribe((result) => {
      for (let i = 1; i < result.data.length; i++) {
        this.videos.push(result.data[i]);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/video/list/category.component.ts